import { PropsWithChildren } from "react";
import { Stack } from "@mui/material";

const MapToolbar: React.FC<PropsWithChildren> = (props) => {
  const { children } = props;

  return (
    <Stack
      direction="row"
      gap={1}
      alignItems="center"
      sx={{
        position: "absolute",
        top: 10,
        insetInline: 10,
      }}
    >
      {children}
    </Stack>
  );
};

export default MapToolbar;
